import {StoreObject, BaseStore, globalStore} from "../../stem-core/state/Store";
import {BaseEnum, makeEnum} from "../../stem-core/state/BaseEnum";
import {field} from "../../stem-core/state/StoreField";
import {apiClient} from "../connection/BlinkApiClient";
import {Merchant} from "./MerchantStore";
import {StoreId} from "../../stem-core/state/State";


@makeEnum
export class PaymentProcessorType extends BaseEnum {
    static BLINK_CREDIT: PaymentProcessorType;
    static STRIPE: PaymentProcessorType;
    static CDS: PaymentProcessorType;
    static AMAZON: PaymentProcessorType;
    static PAYPAL: PaymentProcessorType;
    static CDS_LEGACY: PaymentProcessorType;

    toString(): string {
        if (this === PaymentProcessorType.AMAZON) {
            return "Amazon Pay"
        }
        if (this === PaymentProcessorType.PAYPAL) {
            return "PayPal"
        }
        return super.toString();
    }
}

@globalStore
export class PaymentProcessor extends BaseStore("PaymentProcessor") {
    @field(PaymentProcessorType) provider: PaymentProcessorType;
    @field("Merchant") merchant: any;
    @field("LegalEntity") legalEntity: any;
    @field(String) publicKey: string;
    @field(Object) publicConfig: any;
    @field(Boolean) isPublic: boolean;
    @field(Boolean) isActive: boolean;
    @field(Boolean) isEditable: boolean;
    @field(Boolean) supportsDonations: boolean;
    @field(Boolean) supportsRecurring: boolean;
    declare merchantId: StoreId | null;
    declare legalEntityId: StoreId | null;

    toString(): string {
        return `${this.provider} ${this.isPublic ? "public" : "private"} ${this.merchant || "Blink"}`;
    }

    // Convert this object to be safe for the SDK to handle it
    toSDK() {
        const {
            provider,
            merchantId,
            legalEntityId,
            publicKey,
            publicConfig,
            isPublic,
            isActive,
            supportsDonations,
            supportsRecurring
        } = this;

        return {
            provider,
            merchantId,
            legalEntityId,
            publicKey,
            publicConfig,
            isPublic,
            isActive,
            supportsDonations,
            supportsRecurring
        }
    }

    isBlinkGlobal(): boolean {
        return this.merchantId == null && this.legalEntityId == null;
    }

    canServiceMerchant(merchant?: Merchant): boolean {
        if (this.merchantId === merchant?.id || this.legalEntityId === merchant?.legalEntityId) {
            return true;
        }
        return !this.merchantId && !this.legalEntityId;
    }
}

export async function apiMerchantEditPaymentProcessor(request: any): Promise<any> {
    return apiClient.post("/merchant/edit_payment_processor", request);
}
